import {
    SeaEmissionsAggregatedByCountryLaneAndCarrier,
    SeaEmissionsAggregatedByRouteAndCarrier,
    SeaShippingMetrics,
    SeaShippingRecommendations,
} from '@lune-fe/dapi-models'
import { LoadingWrapper } from '@lune-fe/lune-ui-lib'
import { useEffect, useState } from 'react'

import {
    getCountryLaneAndCarrierMetrics,
    getRouteAndCarrierMetrics,
    getSeaShippingMetrics,
    getSeaShippingRecommendations,
} from 'endpoints/dapi'
import useTitle from 'hooks/useTitle'
import { EnabledView } from 'views/ReduceEmissions/EnabledView'
import { GatedView } from 'views/ReduceEmissions/GatedView'

export const ReduceEmissions = () => {
    useTitle('Reduce Emissions')
    const [headlineMetrics, setHeadlineMetrics] = useState<SeaShippingMetrics | null>(null)
    const [routerAndCarrierMetrics, setRouterAndCarrierMetrics] =
        useState<SeaEmissionsAggregatedByRouteAndCarrier | null>(null)
    const [countryLaneAndCarrierMetrics, setCountryLaneAndCarrierMetrics] =
        useState<SeaEmissionsAggregatedByCountryLaneAndCarrier | null>(null)

    const [recommendations, setRecommendations] = useState<SeaShippingRecommendations | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const params = new URLSearchParams(window.location.search)
    const [organisationId] = params.getAll('organisation_id')

    const loadMetrics = async () => {
        try {
            const metrics = await getSeaShippingMetrics(organisationId)
            const localRouterAnCarrierMetrics = await getRouteAndCarrierMetrics(organisationId)
            const localCountryLaneAndCarrierMetrics =
                await getCountryLaneAndCarrierMetrics(organisationId)
            const recommendations = await getSeaShippingRecommendations(organisationId)
            setHeadlineMetrics(metrics)
            setRouterAndCarrierMetrics(localRouterAnCarrierMetrics)
            setCountryLaneAndCarrierMetrics(localCountryLaneAndCarrierMetrics)
            setRecommendations(recommendations)
        } catch {
            console.log('Organisation does not have access to Reduce Emissions feature.')
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        loadMetrics()
    }, [])

    if (isLoading) {
        return (
            <LoadingWrapper
                loading={true}
                sx={{
                    height: `100vh`,
                    width: `100%`,
                }}
            >
                <></>
            </LoadingWrapper>
        )
    }

    return headlineMetrics &&
        routerAndCarrierMetrics &&
        countryLaneAndCarrierMetrics &&
        recommendations ? (
        <EnabledView
            preview={!!organisationId}
            data={{
                seaShippingMetrics: headlineMetrics,
                routerAndCarrierMetrics,
                countryLaneAndCarrierMetrics,
                recommendations,
            }}
        />
    ) : (
        <GatedView />
    )
}
